import * as React from 'react';
import { createContext, useEffect } from 'react';
import { checkAuthStatus } from '../utils/auth';
import { api } from '../utils/axios';
import { useDispatch } from 'react-redux';
import { authAction } from "../store/authentication";
import {updateSession} from "../utils/session";

interface AuthContextType {
    loading: boolean;
}

export const AuthContext = createContext<AuthContextType>({ loading: true });

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const initAuth = async () => {
            try {
                const { isAuthenticated, isConcierge } = await checkAuthStatus();
                dispatch(authAction.setAuthStatus({ isAuthenticated, isConcierge }));
                if (isAuthenticated) {
                    await updateSession(dispatch);
                }
            } catch (err) {
                console.error('Auth init error', err);
                dispatch(authAction.setAuthStatus({ isAuthenticated: false, isConcierge: false }));
            } finally {
                setLoading(false);
            }
        };

        initAuth();
    }, [dispatch]);

    return (
        <AuthContext.Provider value={{ loading }}>
            {children}
        </AuthContext.Provider>
    );
};
